<template>
  <IonPage>
    <FtrHeader :helpText="helptext_3dscan_page"/>

    <IonContent :color="store.url.includes('kievit') ? 'white' : 'light'" style="display: flex; flex-direction: row; justify-content: space-between; align-items: flex-start; padding: 10px;">
      <ion-grid>
        <ion-row>

          <!-- Left Foot Viewer -->
          <ion-col size-xs="12" size-sm="6" size-md="6" size-lg="4.5" size-xl="4.5">
            <ion-card style="padding: 0; margin-top: 8px; margin-left: 8px; margin-right: 0;" class="custom-card">
              <ion-card-content style="padding: 12px">
                <ion-grid>
                  <ion-row>
                    <ion-col size-xs="12" size-sm="12" size-md="12" size-lg="12" size-xl="11" style="padding: 0; margin: 0">
                      <div style="width: 100%; aspect-ratio: 4 / 5; border: 1px solid var(--ion-color-dark); border-radius: 6px">
                        <transition appear enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                          <div style="width: 100%; height: 100%; border-radius: 5px" ref="target_left"></div>
                        </transition>
                        <q-inner-loading :showing="visible_left">
                          <q-spinner-hourglass size="50px" color="secondary"/>
                          <p style="font-size:1.5em"><b>{{ loading_text_left }}</b></p>
                        </q-inner-loading>
                      </div>
                    </ion-col>


                  </ion-row>
                </ion-grid>
              </ion-card-content>
            </ion-card>
          </ion-col>

          <!-- Middle Column: measurements & actions -->
          <ion-col size-xs="12" size-sm="6" size-md="6" size-lg="3" size-xl="3">
            <ion-card v-if="width_left && width_right" class="custom-card" style="padding: 0; margin-top: 8px; margin-left: 8px; margin-right: 8px; margin-bottom: 16px;">
              <ion-card-content style="padding-inline-start: 10px; padding-inline-end: 10px; display: flex; flex-direction: column;">
                <q-markup-table separator="vertical" dense flat :wrap-cells="true" style="width: 100%">
                  <thead>
                  <tr>
                    <th style="text-align: center; font-size: 10px; font-weight: bold"></th>
                    <th style="padding: 0; text-align: center; font-size: 10px; font-weight: bold">Links</th>
                    <th style="padding: 0; text-align: center; font-size: 10px; font-weight: bold">Rechts</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td style="padding: 0; font-size: 10px; font-weight: bold">Lengte:</td>
                    <td style="padding: 0; text-align: center; font-size: 12px">{{ Math.round(length_left) }}</td>
                    <td style="padding: 0; text-align: center; font-size: 12px">{{ Math.round(length_right) }}</td>
                  </tr>
                  <tr>
                    <td style="padding: 0; font-size: 10px; font-weight: bold">Omvang:</td>
                    <td style="padding: 0; text-align: center; font-size: 12px">{{ Math.round(circumference_left) }}</td>
                    <td style="padding: 0; text-align: center; font-size: 12px">{{ Math.round(circumference_right) }}</td>
                  </tr>
                  <tr>
                    <td style="padding: 0; font-size: 10px; font-weight: bold">Breedte:</td>
                    <td style="padding: 0; text-align: center; font-size: 12px">{{ Math.round(width_left) }}</td>
                    <td style="padding: 0; text-align: center; font-size: 12px">{{ Math.round(width_right) }}</td>
                  </tr>
                  </tbody>
                </q-markup-table>
              </ion-card-content>
            </ion-card>

            <ion-card class="custom-card" style="padding: 0; margin: 8px">
              <ion-card-content style="display: flex; flex-direction: column">
                <ion-button color="secondary" v-if="!files_loaded_left || !files_loaded_right" @click="setOpen(true, 'library')" style="font-size: 12px">
                  <i style="padding-right: 6px" class="fa-regular fa-rectangle-list"></i>
                  Bibliotheek
                </ion-button>
                <ion-button v-if="files_loaded_left && files_loaded_right" color="danger" style="margin-top: 12px;font-size: 12px" @click="removeScans">
                  <i style="padding-right: 6px" class="fa-regular fa-eraser"></i>
                  Remove Scans
                </ion-button>
                <ion-button color="secondary" v-if="files_loaded_left && files_loaded_right" @click="navigate()" style="margin-top: 12px;font-size: 12px">
                  <i style="padding-right: 6px" class="fa-regular fa-chevron-right"></i>
                  Verder
                </ion-button>
              </ion-card-content>
            </ion-card>
            <ion-card style="padding: 0; background-color: #ffffff;">
              <ion-card-content style="display: flex; flex-direction: column; align-items: center; text-align: center;gap:4px">

                <!-- App Icon -->
                <img tappable @click="downloadScannerApp" src="../assets/img/scan_icon.png" alt="FittrScan App Icon" style="width: 120px; height: 120px; border-radius: 18.5%; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);"/>

                <!-- Heading -->
                <div style="font-size: 14px; font-weight: bold; color: #333; margin: 8px 16px 4px;">
                  Heeft u een iPhone met Face ID?
                </div>

                <!-- Description -->
                <p style="font-size: 12px; color: #666; line-height: 1.2; margin: 0;">
                  Scan voeten eenvoudig met <br>—<strong>FittrScan 3D</strong>—<br>
                  geen extra 3D-scanner apparatuur of handmatige uploads meer nodig!<br>
                  Gebruik uw iPhone om te scannen en open de scans direct hier vanuit de bibliotheek. </p>

                <div style="margin-top:12px;display:flex;flex-wrap:nowrap">
                  <q-btn color="secondary" rounded flat @click="downloadScannerApp">
                    <i class="fa-brands fa-app-store" style="font-size: 32px"></i>
                  </q-btn>

                  <q-btn color="secondary" rounded flat @click="copyToClipboard(url)
                    .then(() => {
                      // success!
                    })
                    .catch(() => {
                      // fail
                    });">
                    <i class="fa-regular fa-copy" style="font-size: 22px"></i>
                  </q-btn>
                </div>
              </ion-card-content>
            </ion-card>
          </ion-col>

          <!-- Right Foot Viewer -->
          <ion-col size-xs="12" size-sm="6" size-md="6" size-lg="4.5" size-xl="4.5">
            <ion-card style="padding: 0; margin-top: 8px; margin-left: 0; margin-right: 8px;" class="custom-card">
              <ion-card-content style="padding: 12px">
                <ion-grid>
                  <ion-row>
                    <ion-col size-xs="12" size-sm="12" size-md="12" size-lg="12" size-xl="11" style="padding: 0; margin: 0">
                      <div style="width: 100%; aspect-ratio: 4 / 5; border: 1px solid var(--ion-color-dark); border-radius: 6px">
                        <transition appear enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                          <div style="width: 100%; height: 100%; border-radius: 5px" ref="target_right"></div>
                        </transition>
                        <q-inner-loading :showing="visible_right">
                          <q-spinner-hourglass size="50px" color="secondary"/>
                          <p style="font-size:1.5em"><b>{{ loading_text_right }}</b></p>
                        </q-inner-loading>
                      </div>
                    </ion-col>

                  </ion-row>
                </ion-grid>
              </ion-card-content>
            </ion-card>
          </ion-col>

        </ion-row>
      </ion-grid>

      <!-- Modal for Library -->
      <ion-modal :is-open="isOpen">
        <ion-header>
          <ion-toolbar>
            <ion-buttons slot="start">
              <ion-button @click="setOpen(false, null)">Cancel</ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
          <q-list class="rounded-borders">
            <q-separator spaced/>
            <template v-for="item in library" :key="item.id">

              <q-item>
                <q-item-section>

                  <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
                    <q-item-label style="font-weight: bold;font-size: 1.6em" lines="1">
                      {{ item.client_id_one }}
                    </q-item-label>

                    <ion-button v-if="item.filename_left && item.filename_right" @click="loadScan(item.id)" fill="solid" shape="round">
                      OSB<i style="margin-left: 16px" class="fal fa-arrow-right"></i></ion-button>
                  </div>
                  <q-item-label caption style="font-size: 1.2em">{{ normalizeDate(item.date) }}</q-item-label>


                  <q-markup-table flat bordered style="margin-top: 24px">
                    <thead class="bg-grey">
                    <tr>
                      <th class="text-left">Bestandsnaam</th>
                      <th colspan="2" class="text-center">Download</th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr v-if="item.filename_left">
                      <td class="text-left">{{ item.filename_left.replace('.ply','') }}</td>
                      <td class="text-right">
                        <q-btn flat round @click="downloadScanFromBrowser(item.filename_left.replace('_processed',''))">
                          <img style="height: 24px" src="../assets/ply.png" alt="Download STL"/>
                        </q-btn>
                      </td>
                      <td class="text-right">
                        <q-btn flat round @click="downloadAndConvertPlyToStl(item.filename_left.replace('_processed',''))">
                          <img style="height: 24px" src="../assets/stl.png" alt="Download STL"/>
                        </q-btn>
                      </td>
                    </tr>
                    <tr v-if="item.filename_right">
                      <td class="text-left">{{ item.filename_right.replace('.ply','') }}</td>
                      <td class="text-right">
                        <q-btn flat round @click="downloadScanFromBrowser(item.filename_right.replace('_processed',''))">
                          <img style="height: 24px" src="../assets/ply.png" alt="Download STL"/>
                        </q-btn>
                      </td>
                      <td class="text-right">
                        <q-btn flat round @click="downloadAndConvertPlyToStl(item.filename_right.replace('_processed',''))">
                          <img style="height: 24px" src="../assets/stl.png" alt="Download STL"/>
                        </q-btn>
                      </td>
                    </tr>

                    <tr v-if="item.filename_inlay_left">
                      <td class="text-left">{{ item.filename_inlay_left.replace('.ply','') }}</td>
                      <td class="text-right">
                        <q-btn flat round @click="downloadScanFromBrowser(item.filename_inlay_left.replace('_processed',''))">
                          <img style="height: 24px" src="../assets/ply.png" alt="Download STL"/>
                        </q-btn>
                      </td>
                      <td class="text-right">
                        <q-btn flat round @click="downloadAndConvertPlyToStl(item.filename_inlay_left.replace('_processed',''))">
                          <img style="height: 24px" src="../assets/stl.png" alt="Download STL"/>
                        </q-btn>
                      </td>
                    </tr>
                    <tr v-if="item.filename_inlay_right">
                      <td class="text-left">{{ item.filename_inlay_right.replace('.ply','') }}</td>
                      <td class="text-right">
                        <q-btn flat round @click="downloadScanFromBrowser(item.filename_inlay_right.replace('_processed',''))">
                          <img style="height: 24px" src="../assets/ply.png" alt="Download STL"/>
                        </q-btn>
                      </td>
                      <td class="text-right">
                        <q-btn flat round @click="downloadAndConvertPlyToStl(item.filename_inlay_right.replace('_processed',''))">
                          <img style="height: 24px" src="../assets/stl.png" alt="Download STL"/>
                        </q-btn>
                      </td>
                    </tr>

                    <tr v-if="item.filename_foambox">
                      <td class="text-left">{{ item.filename_foambox.replace('.ply','') }}</td>
                      <td class="text-right">
                        <q-btn flat round @click="downloadScanFromBrowser(item.item.filename_foambox.replace('_processed',''))">
                          <img style="height: 24px" src="../assets/ply.png" alt="Download STL"/>
                        </q-btn>
                      </td>
                      <td class="text-right">
                        <q-btn flat round @click="downloadAndConvertPlyToStl(item.filename_foambox.replace('_processed',''))">
                          <img style="height: 24px" src="../assets/stl.png" alt="Download STL"/>
                        </q-btn>
                      </td>
                    </tr>
                    <tr v-if="item.filename_blueprint">
                      <td class="text-left">{{ item.filename_blueprint.replace('.ply','') }}</td>
                      <td class="text-right">
                        <q-btn flat round @click="downloadScanFromBrowser(item.item.filename_blueprint.replace('_processed',''))">
                          <img style="height: 24px" src="../assets/ply.png" alt="Download STL"/>
                        </q-btn>
                      </td>
                      <td class="text-right">
                        <q-btn flat round @click="downloadAndConvertPlyToStl(item.item.filename_blueprint.replace('_processed',''))">
                          <img style="height: 24px" src="../assets/stl.png" alt="Download STL"/>
                        </q-btn>
                      </td>
                    </tr>

                    </tbody>
                  </q-markup-table>
                </q-item-section>
              </q-item>
              <q-separator spaced/>
            </template>
          </q-list>
        </ion-content>
      </ion-modal>
    </IonContent>
  </IonPage>
</template>

<script setup>
/* ------------------- ALL IMPORTS ------------------- */
import {
  IonButton, IonButtons, IonCard, IonCardContent, IonCol,
  IonContent, IonGrid, IonHeader, IonModal, IonPage,
  IonRow, IonToolbar, IonTitle
} from "@ionic/vue";
import {QMarkupTable, QInnerLoading, QSpinnerHourglass, copyToClipboard} from "quasar";
import {DataStore, SortDirection} from "aws-amplify/datastore";
import {downloadData, getUrl} from "aws-amplify/storage";
import * as THREE from "three";
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";
import {PLYLoader} from "three/examples/jsm/loaders/PLYLoader";
import {STLExporter} from "three/examples/jsm/exporters/STLExporter";

import {onBeforeUnmount, onMounted, ref} from "vue";
import {useRouter, useRoute} from "vue-router";
import FtrHeader from "../components/FtrHeader.vue";
import {helptext_3dscan_page} from "../locales/HelptTextContent";
import {DevFittr3DScans} from "../models";
import {useGlobalStore} from "../store/global";
import {Device} from '@capacitor/device';
import {Share} from '@capacitor/share';

async function isIOSWithFaceID() {
  const info = await Device.getInfo();
  if (info.platform === 'ios' || info.operatingSystem === 'ios') {
    console.log('Device is an iOS device');

    // Get the device model (e.g., "iPhone 15 Pro" or "iPad Pro (11-inch)")
    const model = info.model.toLowerCase();
    // Face ID was first introduced in iPhone X (2017) and iPad Pro (2018)
    // Any iPhone model >= X or iPad Pro >= 2018 should have Face ID (TrueDepth)
    const hasTrueDepth = (
        model.includes('iphone') && !model.includes('iphone 8') && !model.includes('iphone se') // iPhone X and above
    ) || (
        model.includes('ipad pro') && !model.includes('2017') // iPad Pro 2018 and later
    );
    console.log(hasTrueDepth ? 'TrueDepth Camera detected' : 'No TrueDepth Camera');
    return hasTrueDepth;
  } else {

    console.log('Not an iOS device');
    return false;
  }
}

const url = ref('https://apps.apple.com/us/app/fittrscan-3d/id6740188076')

async function downloadScannerApp() {

  const hasTrueDepth = await isIOSWithFaceID();
  if (hasTrueDepth === true) {
    window.location.href = url.value;
  } else {
    await Share.share({
      title: 'Dit apparaat ondersteunt geen TrueDepth-camera (Face ID)',
      text: "Deel deze link met een iPhone of iPad met een TrueDepth-camera (Face ID), of zoek in de App Store naar 'FittrScan 3D'.",
      url: url.value,
    });

  }
}

const store = useGlobalStore();
const router = useRouter();
const route = useRoute();
const visible_left = ref(false);
const visible_right = ref(false);
const loading_text_left = ref('');
const loading_text_right = ref('');
loading_text_left.value = 'Loading 3D file...';
loading_text_right.value = 'Loading 3D file...';
let rotationTimeout;
const isOpen = ref(false);
const contentType = ref("");
const library = ref();

const setOpen = async (open, content) => {
  if (content === "library") {
    DataStore.observeQuery(
        DevFittr3DScans,
        p => p.and(p => [
          p.user.contains(store.logged_in_user.email),
        ]), {
          sort: s => s.date(SortDirection.DESCENDING)
        }
    ).subscribe(snapshot => {
      const {items, isSynced} = snapshot;
      library.value = items;
      contentType.value = "library";
      console.log(`[Snapshot] item count: ${items.length}, isSynced: ${isSynced}`);
    });
    contentType.value = "library";
  }
  isOpen.value = open;
};

const width_left = ref();
const circumference_left = ref();
const length_left = ref();
const width_right = ref();
const circumference_right = ref();
const length_right = ref();
const files_loaded_left = ref(false);
const files_loaded_right = ref(false);


// --------------------------------------------------------------------
// 3) Updated loadScan Function: Convert OBJ scans to binary STL if needed.
// --------------------------------------------------------------------

async function loadScan(id) {
  // Close modal and show loading indicator.
  await setOpen(false);
  visible_left.value = true;
  visible_right.value = true;

  // Query the scan.
  const scan = await DataStore.query(DevFittr3DScans, id);

  console.log(scan)

  // Download PLY files and corresponding landmarks JSON files
  const fileL = await downloadScan(scan.filename_left);
  const fileR = await downloadScan(scan.filename_right);

  // Download landmarks JSON files (replace .ply with _landmarks.json)
  const landmarksFilenameLeft = scan.filename_left.replace('.ply', '_landmarks.json');
  const landmarksFilenameRight = scan.filename_right.replace('.ply', '_landmarks.json');

  let landmarksL = null;
  let landmarksR = null;

  try {
    console.log('Attempting to download landmarks file:', landmarksFilenameLeft);
    const landmarksFileL = await downloadScan(landmarksFilenameLeft);

    // Handle different data types - JSON files might come as text or ArrayBuffer
    let jsonText;
    if (landmarksFileL.body instanceof ArrayBuffer) {
      jsonText = new TextDecoder().decode(landmarksFileL.body);
    } else if (typeof landmarksFileL.body === 'string') {
      jsonText = landmarksFileL.body;
    } else {
      // Try to convert to text
      jsonText = await landmarksFileL.body.text();
    }

    landmarksL = JSON.parse(jsonText);
    console.log('Successfully loaded landmarks for left foot:', landmarksL);

    // Extract measurements for left foot
    if (landmarksL.measurements) {
      length_left.value = landmarksL.measurements.length?.value || null;
      width_left.value = landmarksL.measurements.width?.value || null;
      circumference_left.value = landmarksL.measurements.circumference?.value || null;
      console.log('Left foot measurements:', {
        length: length_left.value,
        width: width_left.value,
        circumference: circumference_left.value
      });
    }
  } catch (error) {
    console.log('No landmarks file found for left foot:', landmarksFilenameLeft, error);
  }

  try {
    console.log('Attempting to download landmarks file:', landmarksFilenameRight);
    const landmarksFileR = await downloadScan(landmarksFilenameRight);

    // Handle different data types - JSON files might come as text or ArrayBuffer
    let jsonText;
    if (landmarksFileR.body instanceof ArrayBuffer) {
      jsonText = new TextDecoder().decode(landmarksFileR.body);
    } else if (typeof landmarksFileR.body === 'string') {
      jsonText = landmarksFileR.body;
    } else {
      // Try to convert to text
      jsonText = await landmarksFileR.body.text();
    }

    landmarksR = JSON.parse(jsonText);
    console.log('Successfully loaded landmarks for right foot:', landmarksR);

    // Extract measurements for right foot
    if (landmarksR.measurements) {
      length_right.value = landmarksR.measurements.length?.value || null;
      width_right.value = landmarksR.measurements.width?.value || null;
      circumference_right.value = landmarksR.measurements.circumference?.value || null;
      console.log('Right foot measurements:', {
        length: length_right.value,
        width: width_right.value,
        circumference: circumference_right.value
      });
    }
  } catch (error) {
    console.log('No landmarks file found for right foot:', landmarksFilenameRight, error);
  }

  // For each file, check if it's an OBJ.
  const leftFileData = {file: fileL.body, filename: scan.filename_left};
  const rightFileData = {file: fileR.body, filename: scan.filename_right};

  // Load the models concurrently using the (now assured) STL file.
  loadSTL("left", leftFileData.file, leftFileData.filename, landmarksL);
  loadSTL("right", rightFileData.file, rightFileData.filename, landmarksR);
}

// --------------------------------------------------------------------
// 4) Your Existing downloadScan Function (unchanged)
// --------------------------------------------------------------------

async function downloadScan(filename) {
  return await downloadData({
    path: "public/3DScans/" + filename,
    options: {
      onProgress: (event) => {
        console.log(event.transferredBytes);
      },
    },
  }).result;
}

async function downloadScanFromBrowser(filename) {
  console.log(filename)
  const getUrlResult = await getUrl({
    path: "public/3DScans/" + filename,
    // Alternatively, path: ({identityId}) => `protected/${identityId}/album/2024/1.jpg`
    options: {
      validateObjectExistence: false,  // Check if object exists before creating a URL
    },
  });
  console.log('signed URL: ', getUrlResult.url);
  console.log('URL expires at: ', getUrlResult.expiresAt);
  //window.open(getUrlResult.url)
  window.location.href = getUrlResult.url;
}

async function downloadAndConvertPlyToStl(filename) {
  try {
    console.log('Starting PLY to STL conversion for:', filename);

    // Step 1: Download the PLY file from S3
    const plyFile = await downloadData({
      path: "public/3DScans/" + filename,
      options: {
        onProgress: (event) => {
          console.log('Download progress:', event.transferredBytes);
        },
      },
    }).result;

    console.log('PLY file downloaded successfully');

    // Step 2: Load and parse the PLY file using Three.js
    const loader = new PLYLoader();
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
      reader.onload = (e) => {
        try {
          const contents = e.target.result;

          // Parse PLY geometry
          const geometry = loader.parse(contents);
          geometry.computeVertexNormals();

          console.log('PLY geometry parsed successfully');

          // Step 3: Create a mesh from the geometry
          const material = new THREE.MeshBasicMaterial({color: 0xDFC4B2});
          const mesh = new THREE.Mesh(geometry, material);

          // Step 4: Export to STL using STLExporter
          const exporter = new STLExporter();
          const stlString = exporter.parse(mesh);

          console.log('STL conversion completed');

          // Step 5: Create blob and download
          const blob = new Blob([stlString], {type: 'application/octet-stream'});
          const url = URL.createObjectURL(blob);

          // Create download link
          const link = document.createElement('a');
          link.href = url;
          link.download = filename.replace('.ply', '.stl');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Clean up
          URL.revokeObjectURL(url);

          console.log('STL file downloaded successfully as:', filename.replace('.ply', '.stl'));
          resolve();

        } catch (error) {
          console.error('Error during PLY to STL conversion:', error);
          reject(error);
        }
      };

      reader.onerror = (error) => {
        console.error('Error reading PLY file:', error);
        reject(error);
      };

      reader.readAsArrayBuffer(plyFile.body);
    });

  } catch (error) {
    console.error('Error downloading or converting PLY file:', error);
    throw error;
  }
}


/* ------------------- HELPER: Format Date ------------------- */
function normalizeDate(date) {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const mon = String(d.getMonth() + 1).padStart(2, "0");
  const yr = d.getFullYear();
  const hrs = String(d.getHours()).padStart(2, "0");
  const mins = String(d.getMinutes()).padStart(2, "0");
  return `${day}-${mon}-${yr} ${hrs}:${mins}`;
}

/* ------------------------------------------------------
 3D Scenes, Cameras, Renderers, & OnMounted
 ------------------------------------------------------ */
const target_left = ref(null);
const target_right = ref(null);

let scene_left, camera_left, renderer_left, controls_left, footModel_left = null;
let scene_right, camera_right, renderer_right, controls_right, footModel_right = null;

function createSceneAndRenderer(container) {
  const scene = new THREE.Scene();
  scene.background = new THREE.Color(0xffffff);

  // Target aspect ratio: 2 (width) : 3 (height)
  const targetAspect = 4 / 5;

  // Function to compute dimensions that maintain the target aspect ratio.
  function computeDimensions() {
    const containerWidth = container.clientWidth;
    const containerHeight = container.clientHeight;
    let newWidth, newHeight;
    if (containerWidth / containerHeight > targetAspect) {
      // Container is too wide: limit by height.
      newHeight = containerHeight;
      newWidth = newHeight * targetAspect;
    } else {
      // Container is too tall: limit by width.
      newWidth = containerWidth;
      newHeight = newWidth / targetAspect;
    }
    return {newWidth, newHeight};
  }

  const {newWidth, newHeight} = computeDimensions();

  // Create a camera with the computed aspect ratio.
  const camera = new THREE.PerspectiveCamera(40, newWidth / newHeight, 0.1, 5000);
  camera.position.set(0, 450, 0);
  camera.lookAt(0, 0, 0);
  camera.up.set(0, 1, 0);

  const renderer = new THREE.WebGLRenderer({antialias: true});
  renderer.setSize(newWidth, newHeight);
  renderer.shadowMap.enabled = true;
  renderer.localClippingEnabled = true;

  // Add lights as before.
  const ambientLight = new THREE.AmbientLight(0xffffff, 1.2);
  scene.add(ambientLight);

  const dirLight1 = new THREE.DirectionalLight(0xffffff, 2);
  dirLight1.position.set(50, 50, 100);
  dirLight1.castShadow = true;
  scene.add(dirLight1);

  const dirLight2 = new THREE.DirectionalLight(0xffffff, 1.5);
  dirLight2.position.set(-50, 50, -100);
  dirLight2.castShadow = true;
  scene.add(dirLight2);

  const dirLight3 = new THREE.DirectionalLight(0xffffff, 1);
  dirLight3.position.set(0, 100, 0);
  dirLight3.castShadow = true;
  scene.add(dirLight3);

  const gridHelper = new THREE.GridHelper(400, 40);
  scene.add(gridHelper);

  const controls = new OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true;
  controls.dampingFactor = 0.05;

  // Resize handler to maintain the 2:3 aspect ratio.
  const resizeRenderer = () => {
    const {newWidth, newHeight} = computeDimensions();
    renderer.setSize(newWidth, newHeight);
    camera.aspect = newWidth / newHeight;
    camera.updateProjectionMatrix();
  };
  const resizeObserver = new ResizeObserver(resizeRenderer);
  resizeObserver.observe(container);

  onBeforeUnmount(() => resizeObserver.disconnect());
  resizeRenderer();

  return {scene, camera, renderer, controls};
}

function animateBoth() {
  requestAnimationFrame(animateBoth);
  if (controls_left && scene_left && camera_left && renderer_left) {
    controls_left.update();
    renderer_left.render(scene_left, camera_left);
  }
  if (controls_right && scene_right && camera_right && renderer_right) {
    controls_right.update();
    renderer_right.render(scene_right, camera_right);
  }
}

onMounted(() => {
  if (target_left.value) {
    const setupLeft = createSceneAndRenderer(target_left.value);
    scene_left = setupLeft.scene;
    camera_left = setupLeft.camera;
    renderer_left = setupLeft.renderer;
    controls_left = setupLeft.controls;
    target_left.value.appendChild(renderer_left.domElement);
    console.log("Left scene created with lights:", scene_left.children.filter(c => c.isLight));
    console.log("Left scene children:", scene_left.children);
  }

  if (target_right.value) {
    const setupRight = createSceneAndRenderer(target_right.value);
    scene_right = setupRight.scene;
    camera_right = setupRight.camera;
    renderer_right = setupRight.renderer;
    controls_right = setupRight.controls;
    target_right.value.appendChild(renderer_right.domElement);
    console.log("Right scene created with lights:", scene_right.children.filter(c => c.isLight));
    console.log("Right scene children:", scene_right.children);
  }

  animateBoth();
});

onBeforeUnmount(() => {
  // Cleanup if needed
});

function addLandmarksToScene(scene, landmarks, side, yOffset) {
  console.log(`Processing ${landmarks.length} landmarks for ${side} foot with Y-offset: ${yOffset}`);

  landmarks.forEach((landmark, index) => {
    console.log(`Processing landmark ${index}:`, landmark.label, landmark.pos_mm, landmark.col);

    // Create sphere geometry for landmark - make it much bigger for visibility
    const sphereGeometry = new THREE.SphereGeometry(5, 16, 16); // 5mm radius - much bigger

    // Convert color from array [r,g,b] to THREE.Color
    let color = new THREE.Color(0xff0000); // Default red
    if (landmark.col && landmark.col.length >= 3) {
      color = new THREE.Color(landmark.col[0], landmark.col[1], landmark.col[2]);
    }

    console.log(`Creating sphere with color:`, color, `from col:`, landmark.col);

    // Create material with the landmark color - make it very visible
    const sphereMaterial = new THREE.MeshPhongMaterial({
      color: color,
      transparent: false, // Make it solid
      opacity: 1.0,
      emissive: color.clone().multiplyScalar(0.2) // Add some glow
    });

    // Create mesh
    const sphereMesh = new THREE.Mesh(sphereGeometry, sphereMaterial);

    // Position the sphere using pos_mm coordinates (already correctly scaled for PLY)
    if (landmark.pos_mm && landmark.pos_mm.length >= 3) {
      // Use pos_mm directly - same scale as PLY
      const x = landmark.pos_mm[0];
      const y = landmark.pos_mm[1];
      const z = landmark.pos_mm[2];

      console.log(`Original coordinates for ${landmark.label}: x=${x}, y=${y}, z=${z}`);

      // Apply PLY rotation (90°) + additional 180° rotation for landmarks
      if (side === "left") {
        // Left foot: 90° counter-clockwise + 180° -> Original: x, y, z -> After 90°: -z, y, x -> After +180°: z, y, -x
        sphereMesh.position.set(z, y + yOffset, -x);
        console.log(`Left foot transformed position: x=${z}, y=${y + yOffset}, z=${-x}`);
      } else {
        // Right foot: 90° clockwise + 180° -> Original: x, y, z -> After 90°: z, y, -x -> After +180°: -z, y, x
        sphereMesh.position.set(-z, y + yOffset, x);
        console.log(`Right foot transformed position: x=${-z}, y=${y + yOffset}, z=${x}`);
      }
    } else if (landmark.pos && landmark.pos.length >= 3) {
      // Fallback to pos coordinates (already in meters)
      const x = landmark.pos[0] * 1000; // Convert to mm scale
      const y = landmark.pos[1] * 1000;
      const z = landmark.pos[2] * 1000;

      console.log(`Using pos coordinates for ${landmark.label}: x=${x}, y=${y}, z=${z}`);

      // Apply the same rotation as the PLY model (90° + 180°)
      if (side === "left") {
        // Left foot: 90° counter-clockwise + 180°
        sphereMesh.position.set(z, y + yOffset, -x);
        console.log(`Left foot transformed position: x=${z}, y=${y + yOffset}, z=${-x}`);
      } else {
        // Right foot: 90° clockwise + 180°
        sphereMesh.position.set(-z, y + yOffset, x);
        console.log(`Right foot transformed position: x=${-z}, y=${y + yOffset}, z=${x}`);
      }
    }

    // Add label as userData for potential future use
    sphereMesh.userData = {
      label: landmark.label,
      landmarkIndex: landmark.labelIndex
    };

    // Add to scene
    scene.add(sphereMesh);
    console.log(`Added landmark sphere for ${landmark.label} to scene at position:`, sphereMesh.position);
    console.log(`Scene now has ${scene.children.length} children`);
  });

  console.log(`Finished adding ${landmarks.length} landmarks to ${side} foot scene`);
  console.log(`Final scene children count: ${scene.children.length}`);
  console.log(`Scene children:`, scene.children.map(child => child.type || child.constructor.name));
}

function loadSTL(side, file, filename, landmarks) {
  const {
    scene,
  } = (side === "left")
      ? {
        scene: scene_left,
        widthRef: width_left,
        circumferenceRef: circumference_left,
        lengthRef: length_left
      }
      : {
        scene: scene_right,
        widthRef: width_right,
        circumferenceRef: circumference_right,
        lengthRef: length_right
      };

  // 2) Choose loader based on extension
  let loader;
  loader = new PLYLoader();

  const reader = new FileReader();
  reader.readAsArrayBuffer(file);

  // 4) When the file has loaded, parse and build your foot model
  reader.onload = (e) => {
    let contents = e.target.result;

    let footModel;
// STL/PLY case: parse into a geometry
    const geometry = loader.parse(contents);
    geometry.computeVertexNormals();

// Check if the model has color attributes
    const hasColors = geometry.attributes.color !== undefined;

// Define material
    const material = new THREE.MeshPhongMaterial({
      vertexColors: hasColors, // Use vertex colors if present
      color: hasColors ? undefined : new THREE.Color(0xDFC4B2), // Skin-like color if no colors are in the model
      shininess: 50,
      transparent: true,
      opacity: 1,
    });

    footModel = new THREE.Mesh(geometry, material);
    footModel.castShadow = true;
    footModel.receiveShadow = true;

    // Rotate 90 degrees - counter-clockwise for left foot, clockwise for right foot
    if (side === "left") {
      footModel.rotation.y = Math.PI / 2; // 90 degrees counter-clockwise
    } else {
      footModel.rotation.y = -Math.PI / 2; // 90 degrees clockwise
    }

    // Calculate bounding box to position model just above the grid
    geometry.computeBoundingBox();
    const boundingBox = geometry.boundingBox;
    const yOffset = -boundingBox.min.y; // Move up so bottom of model is at y=0
    footModel.position.y = yOffset;

    // 7) Add foot model to the scene
    scene.add(footModel);

    // 8) Add landmarks if available
    if (landmarks && landmarks.landmarks) {
      console.log(`Adding ${landmarks.landmarks.length} landmarks for ${side} foot:`, landmarks.landmarks);
      addLandmarksToScene(scene, landmarks.landmarks, side, yOffset);
    } else {
      console.log(`No landmarks found for ${side} foot. Landmarks object:`, landmarks);
    }

    if (side === "left") {
      loading_text_left.value = 'Voet correct positioneren...';
    } else {
      loading_text_right.value = 'Voet correct positioneren...';
    }

    // 9) If we're loading left foot, store reference; likewise for right foot
    if (side === "left") {
      footModel_left = footModel;
      files_loaded_left.value = true;
      visible_left.value = false;
    } else {
      footModel_right = footModel;
      files_loaded_right.value = true;
      visible_right.value = false;
    }
  };
}

/* ------------------- REMOVE SCANS ------------------- */
function removeScans() {
  if (footModel_left && scene_left) {
    scene_left.remove(footModel_left);
    footModel_left.geometry?.dispose();
    if (Array.isArray(footModel_left.material)) {
      footModel_left.material.forEach((m) => m.dispose());
    } else {
      footModel_left.material?.dispose();
    }
    footModel_left = null;
  }

  if (footModel_right && scene_right) {
    scene_right.remove(footModel_right);
    footModel_right.geometry?.dispose();
    if (Array.isArray(footModel_right.material)) {
      footModel_right.material.forEach((m) => m.dispose());
    } else {
      footModel_right.material?.dispose();
    }
    footModel_right = null;
  }

  files_loaded_left.value = false;
  files_loaded_right.value = false;
  width_left.value = null;
  width_right.value = null;
  circumference_left.value = null;
  circumference_right.value = null;
  length_left.value = null;
  length_right.value = null;

}

/* ------------------- MISC NAVIGATE ------------------- */
async function navigate() {
  store.scanLengthLeft = Math.round(length_left.value);
  store.scanWidthLeft = Math.round(width_left.value);
  store.scanCircumfenceLeft = Math.round(circumference_left.value);

  store.scanLengthRight = Math.round(length_right.value);
  store.scanWidthRight = Math.round(width_right.value);
  store.scanCircumfenceRight = Math.round(circumference_right.value);

  await router.push("/osb/foot-dimensions/" + store.category);
}


</script>

<style scoped>
canvas {
  border-radius: 15px !important;
}
</style>